import React from 'react'
import { useContent } from '../../contexts/ContentContext'
import { useNavigation } from '../../contexts/NavigationContext'
import MultiPlayer from '../ui/MultiPlayer'
import { ChevronDown } from 'lucide-react'

export default function HeroV3Section() {
  const { hero } = useContent()
  const { navigateTo } = useNavigation()

  const handleScrollDown = () => {
    // Exit fullscreen first if in fullscreen
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {
        // Ignore exit errors, proceed with scroll
      })
    }

    // Scroll to welcome section (same logic as menu)
    navigateTo('#welcome')
  }

  const handleVideoPlay = () => {
    // Callback when video starts (fullscreen is handled by MultiPlayer)
  }

  return (
    <section id="hero" className="flex flex-col overflow-hidden relative snap-section" data-testid="hero-section">

      {/* HEADLINE — spacing to video */}
      <div className="pt-16 pb-2 md:pt-20 md:pb-3 px-6 md:px-14 lg:px-20 flex-shrink-0">
        <div className="w-full max-w-mobile-content sm:max-w-[600px] md:max-w-[700px] lg:max-w-[783px] mx-auto text-left">
          <span className="typography-hero-h1-mobile md:typography-hero-large effect-drop-display-light uppercase leading-tight md:leading-[0.85] inline">
            {hero.headlineLine1}&nbsp;
          </span>
          <span className="typography-hero-h1-mobile md:typography-hero effect-drop-display-light italic text-right inline-block w-full -mt-6 md:-mt-10">
            {hero.headlineLine2}
          </span>

        </div>
      </div>

      {/* VIDEO — responsive width */}
      <div className="px-6 md:px-14 lg:px-20 w-full">
        <div className="w-full max-w-mobile-content sm:max-w-[600px] md:max-w-[700px] lg:max-w-[720px] mx-auto">
          <MultiPlayer
            key={hero.videoUrl}
            type="r2"
            src={hero.videoUrl}
            poster={hero.posterUrl}
            autoFullscreen={true}
            onVideoPlay={handleVideoPlay}
            onVideoEnded={handleScrollDown}
          />
        </div>
      </div>

      {/* CTA — centered below video */}
      <div className="px-6 md:px-14 lg:px-20 pt-2 md:pt-3">
        <div className="w-full max-w-mobile-content sm:max-w-[600px] md:max-w-[700px] lg:max-w-[783px] mx-auto text-center">
          <p className="typography-hero-h1-mobile md:typography-hero effect-drop-display-light italic">
            {hero.heroCta}
          </p>
        </div>
      </div>

      {/* Arrow */}
      <div className="px-6 md:px-14 lg:px-20 pt-0 pb-2 md:pt-1 md:pb-3">
        <div className="w-full max-w-mobile-content sm:max-w-[600px] md:max-w-[700px] lg:max-w-[783px] mx-auto flex justify-center" data-testid="hero-cta-scroll">
          <button
            onClick={handleScrollDown}
            aria-label="Nach unten scrollen"
            className="opacity-50 hover:opacity-80 transition-opacity duration-300"
          >
            <ChevronDown
              size={32}
              className="md:!w-[44px] md:!h-[44px] animate-pulse-down"
            />
          </button>
        </div>
      </div>
    </section>
  )
}
